

import XHeader from 'vux/src/components/x-header/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import dialogBar from './lawDialog.vue';

export default {
components: {
XHeader,
Alert,
'dialog-bar': dialogBar
},
data () {
return {
show: false,
message:'',
lawText:"",
model:{mobile:"",password:"",code:"",sourceUrl:null},
check:"check checked",
isCheck:false,
isCode:false,
sendVal: false,
timer:60,
sendStr:"发送验证码"
}
},
created(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/userAuth/getLaw',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success){
this.lawText=res.body.moreLaw;
}
},function(res){
console.log(res);
});
},
methods: {
goBack(){

this.$router.push({
path : '/auth/login',
query : {}
})
},
openMask(index){
this.sendVal = true;
},
clickCancel(){
this.check = "check checked";
},
clickDanger(){
console.log('这里是danger回调')
},
clickConfirm(){
this.check = "check";
},
sendCode:function(){


if(this.verifyMobile()){
return;
}


this.$http.post(this.global.httpUrl + '/rest/v1/m/user/userAuth/send',{mobile:this.model.mobile},{emulateJSON:true}).then(function(json){
if (!json.body.success) {
this.show=true ;
this.message=json.body.message;
} else {
if(json.body.code == -11)
{
this.show=true ;
this.message="您今日已超过短信上限!";
return ;
} else if(json.body.code == 1){
this.timer = json.body.max;
}else
{
this.timer = json.body.time;
}
this.isCode = true;
let auth_timer = setInterval(()=>{  //定时器设置每秒递减
this.timer--;        
this.sendStr = this.timer+"s后重发";
if(this.timer<=0){
this.isCode = false;
this.sendStr = "发送验证码";    
clearInterval(auth_timer)
}
},1000);
}
},function(res){
console.log(res);
});


},
register:function(){


if(this.verifyMobile()){
return;
}

if(this.model.password == ""){
this.show=true ;
this.message="密码不能为空!";
return;
}
if(!/^[^ ]{6,16}$/.test(this.model.password)){
this.show=true ;
this.message="密码格式错误(6-16位密码，不能有空格)!";
return;
}
if(this.model.code == ""){
this.show=true ;
this.message="验证码不能为空!";
return;
}

this.model.sourceUrl = this.$cookies.get("sourceUrl");
if(this.check == "check"){
this.show=true ;
this.message="请同意用户注册协议!";
return;
}


let rasPw = this.$getRsaCode(this.model.password);

let entity = {mobile:this.model.mobile,password:rasPw,code:this.model.code,sourceUrl:this.model.sourceUrl};

this.$http.post(this.global.httpUrl + '/rest/v1/m/user/userAuth/register',entity,{emulateJSON:true}).then(function(res){
this.model.m_token=res.body.token;
if(res.body.success){
this.setUser(res.body.token,res.body.mobile);
this.$router.push("/auth/registerSuccess?morewisNumber="+res.body.morewisNumber);
}else{
this.show=true ;
this.message=res.body.message;
}
},function(res){
console.log(res);
});

},
agreeLaw:function(){
console.log(this.check)
if(this.check == "check"){
this.check = "check checked";
}else{
this.check = "check";
}
},
verifyMobile:function(){
var mobile = this.model.mobile;

if(mobile == ""){
this.show=true ;
this.message="手机号码不能为空!";
return true;
}

if(!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(mobile)){
this.show=true ;
this.message="手机号码格式不正确!";
return true;
}

return false;
}

}
}



// WEBPACK FOOTER //
// ./src/views/auth/register.vue